import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { of, Observable } from 'rxjs';
import { catchError, mapTo, tap, map } from 'rxjs/operators';
// import * as moment from 'moment';
// import * as moment_tz from 'node_modules/moment-timezone';

import axios from "axios";


@Injectable({ providedIn: 'root' })
export class YieldReportService {
    private defaultUrl: any;
    private defaultUrlControl: any;
    constructor(private http: HttpClient) {

        this.defaultUrl = axios.create({
            baseURL: environment.API
        });

        this.defaultUrlControl = axios.create({
            baseURL: environment.API_CONTROL
        });
    }
    public getBreedTypeByFarm(data): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_BREED_TYPE_BY_FARM}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getPlotList(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_PLOT_LIST}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getPoleList(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_POLE_LIST}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getReportYieldBreed(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_REPORT_YIELD_BREED}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getReportYieldFarm(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_REPORT_YIELD_FARM}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getReportYieldList(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_REPORT_YIELD_LIST}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    public getReportYieldDetail(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_REPORT_YIELD_DETAIL}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    
    
}